import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavigationBar() {
  const { pathname } = useLocation();

  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand">
          <div className="nav-brand-clip">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 8h6M8 5v6" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
          TaxClip
        </Link>
        <div className="nav-links">
          <Link to="/" className={`nav-link${pathname === '/' ? ' active' : ''}`}>Home</Link>
          <Link to="/calculator" className={`nav-link${pathname === '/calculator' ? ' active' : ''}`}>Calculator</Link>
          <Link to="/about" className={`nav-link${pathname === '/about' ? ' active' : ''}`}>About</Link>
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
